import { createRouter, createWebHistory } from 'vue-router';
import AuthService from '../services/AuthService';
import AdminAuthService from '../services/admin/AdminAuthService';
import AdminLogin from '../views/admin/AdminLogin.vue';
import AdminSetup from '../views/admin/AdminSetup.vue';
import AdminDashboard from '../views/admin/AdminDashboard.vue';
import AdminCompanyDetail from '../views/admin/AdminCompanyDetail.vue';
import AdminMrr from '../views/admin/AdminMrr.vue';
import AdminEmails from '../views/admin/AdminEmails.vue';
import AdminCoupons from '../views/admin/AdminCoupons.vue';
import AdminCouponDetail from '../views/admin/AdminCouponDetail.vue';

const ADMIN_PUBLIC_ROUTES = ['adminLogin', 'adminSetup'];
const ADMIN_ROUTES = ['adminLogin', 'adminSetup', 'adminDashboard', 'adminCompanyDetail', 'adminMrr', 'adminEmails', 'adminCoupons', 'adminCouponNew', 'adminCouponDetail'];
import Login from '../views/Login.vue';
import Profile from '../views/Profile.vue';
import Home from '../views/Home.vue';
import Account from '../views/Account.vue';
import ChangePassword from '../views/ChangePassword.vue';
import Drive from '../views/Drive.vue';
import Matrix from '../views/Matrix.vue';
import Patients from '../views/Patients.vue';
import Preferences from '../views/Preferences.vue';
import Records from '../views/Records.vue';
import Evaluations from '../views/Evaluations.vue';
import Reports from '../views/Reports.vue';
import Users from '../views/Users.vue';
import PatientForm from '../views/PatientForm.vue';
import RecordForm from '../views/RecordForm.vue';
import ConclusionDetail from '../views/ConclusionDetail.vue';
import AciasDetail from '../views/AciasDetail.vue';
import CreateAccount from '../views/CreateAccount.vue';
import Security from '../views/Security.vue';
import Subscription from '../views/Subscription.vue';
import UsageLimits from '../views/UsageLimits.vue';
import CheckoutSuccess from '../views/CheckoutSuccess.vue';
import CheckoutCancel from '../views/CheckoutCancel.vue';
import AcceptInvite from '../views/AcceptInvite.vue';
import ForgotPassword from '../views/ForgotPassword.vue';
import ResetPassword from '../views/ResetPassword.vue';
import ConfirmEmail from '../views/ConfirmEmail.vue';

const PUBLIC_ROUTES = ['login', 'createAccount', 'auth', 'checkoutSuccess', 'checkoutCancel', 'acceptInvite', 'forgotPassword', 'resetPassword', 'confirmEmail'];

const routes = [
	{
		path: '/',
		name: 'auth',
		component: Login
	},
	{
		path: '/login',
		name: 'login',
		component: Login
	},
	{
		path: '/criar-conta',
		name: 'createAccount',
		component: CreateAccount
	},
	{
		path: '/esqueci-senha',
		name: 'forgotPassword',
		component: ForgotPassword
	},
	{
		path: '/meu-perfil',
		name: 'my-profile',
		component: Profile
	},
	{
		path: '/perfil/:uuid?',
		name: 'profile',
		component: Profile
	},
	{
		path: '/home',
		name: 'home',
		component: Home
	},
	{
		path: '/minha-conta',
		name: 'account',
		component: Account
	},
	{
		path: '/mudar-minha-senha',
		name: 'changePassword',
		component: ChangePassword
	},
	{
		path: '/matriz-de-risco/:record_uuid/:patient_uuid/:matrix_uuid?',
		name: 'matrix',
		component: Matrix
	},
	{
		path: '/pacientes',
		name: 'patients',
		component: Patients
	},
	{
		path: '/avaliacoes',
		name: 'evaluations',
		component: Evaluations
	},
	{
		path: '/preferencias',
		name: 'preferences',
		component: Preferences
	},
	{
		path: '/prontuario/:uuid',
		name: 'records',
		component: Records
	},
	{
		path: '/relatorios',
		name: 'reports',
		component: Reports
	},
	{
		path: '/usuarios',
		name: 'users',
		component: Users
	},
	{
		path: '/paciente/:uuid?',
		name: 'patientForm',
		component: PatientForm
	},
	{
		path: '/avaliacao/:patient_uuid/:record_uuid?',
		name: 'avaliation',
		component: RecordForm
	},
	{
		path: '/avaliacao/:patient_uuid/:record_uuid/conclusao',
		name: 'recordConclusion',
		component: ConclusionDetail
	},
	{
		path: '/acias/:patient_uuid/:acias_uuid',
		name: 'aciasDetail',
		component: AciasDetail
	},
	{
		path: '/seguranca',
		name: 'security',
		component: Security
	},
	{
		path: '/assinatura',
		name: 'subscription',
		component: Subscription
	},
	{
		path: '/limites-de-uso',
		name: 'usageLimits',
		component: UsageLimits
	},
	{
		path: '/checkout/success',
		name: 'checkoutSuccess',
		component: CheckoutSuccess
	},
	{
		path: '/checkout/cancel',
		name: 'checkoutCancel',
		component: CheckoutCancel
	},
	{
		path: '/convite/:token',
		name: 'acceptInvite',
		component: AcceptInvite
	},
	{
		path: '/redefinir-senha/:token',
		name: 'resetPassword',
		component: ResetPassword
	},
	{
		path: '/confirmar-email/:token',
		name: 'confirmEmail',
		component: ConfirmEmail
	},

	// ADMIN — rotas isoladas, sem layout principal, sem a palavra "admin" na URL
	{
		path: '/:uuid/login',
		name: 'adminLogin',
		component: AdminLogin
	},
	{
		path: '/:uuid/setup',
		name: 'adminSetup',
		component: AdminSetup
	},
	{
		path: '/:uuid/dashboard',
		name: 'adminDashboard',
		component: AdminDashboard
	},
	{
		path: '/:uuid/companies/:id',
		name: 'adminCompanyDetail',
		component: AdminCompanyDetail
	},
	{
		path: '/:uuid/mrr',
		name: 'adminMrr',
		component: AdminMrr
	},
	{
		path: '/:uuid/emails',
		name: 'adminEmails',
		component: AdminEmails
	},
	{
		path: '/:uuid/coupons',
		name: 'adminCoupons',
		component: AdminCoupons
	},
	{
		path: '/:uuid/coupons/new',
		name: 'adminCouponNew',
		component: AdminCouponDetail
	},
	{
		path: '/:uuid/coupons/:couponId',
		name: 'adminCouponDetail',
		component: AdminCouponDetail
	},
]

const router = createRouter({
	history: createWebHistory(process.env.BASE_URL),
	routes,
	scrollBehavior(to, from, savedPosition) {
		if (
			to.name === 'avaliation'
			&& from.name === 'avaliation'
			&& !from.params.record_uuid
			&& to.params.record_uuid
		) {
			return false;
		}

		return { top: 0 }
	},
})

router.beforeEach((to, from, next) => {
	// Guard para rotas admin
	if (ADMIN_ROUTES.includes(to.name)) {
		const expectedUuid = process.env.VUE_APP_ADMIN_UUID;
		if (!expectedUuid || to.params.uuid !== expectedUuid) {
			return next({ name: 'login' });
		}
		if (!ADMIN_PUBLIC_ROUTES.includes(to.name) && !AdminAuthService.isAuthenticated()) {
			return next({ name: 'adminLogin', params: { uuid: to.params.uuid } });
		}
		return next();
	}

	// Guard para rotas normais
	if (!PUBLIC_ROUTES.includes(to.name) && !AuthService.isAuthenticated()) {
		return next({ name: 'login' });
	}

	// Redirect to subscription page when trial is expired and not on an allowed route
	if (AuthService.isAuthenticated() && !PUBLIC_ROUTES.includes(to.name)) {
		const auth = AuthService.getAuthInfo() || {};
		const status = auth.subscription_status;
		const hasActivePlan = status === 'active' || status === 'past_due' || status === 'trial';
		if (!hasActivePlan && to.name !== 'subscription' && to.name !== 'account') {
			return next({ name: 'subscription' });
		}
	}

	return next();
})

export default router
